module.exports = __webpack_public_path__ + "img/print_lipsprint@2x.dd29d9e.webp";